export default {
      id: "sources-usage",
      viewBox: "0 0 431.67 512",
      url: "assets/" + "sprite.svg#sources-usage",
      toString: function () {
        return this.url;
      }
    }